import * as _ from 'lodash';

import { api } from '../axiosConfig';
import {surveysURL, samplesURL} from "../Utils/urls";

export class SamplesAPI {
    static getAll(
        limit : any,
        currentPageNumber : number,
        payload: { [key: string]: any },
        offset = 0,
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getAll/${limit}/${currentPageNumber}`,payload).then((res) => {
            return _.get(res, 'data', []);
        });
    }

    static create(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${samplesURL}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOne(
        id : string
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getOne/${id}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }


    static getOneSampleUsers(
        id : string,
        page,
        limit
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getOneSampleUsers/${id}?page=${page}&limit=${limit}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static update(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${samplesURL}/update/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static deleteOne(id: string): Promise<any> {
        return api.post(`${samplesURL}/delete/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }


    static createQuestion(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${samplesURL}/create-questions`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOneQuestion(id: any): Promise<any> {
        return api.post(`${samplesURL}/get-SampleQuestion/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getQuestions(secId: any): Promise<any> {
        return api.post(`${samplesURL}/get-SampleQuestions/${secId}`, {})
            .then((res) => {
                return _.get(res, 'data.data', []);
            });
    }

    static removeQuestion(id: any): Promise<any> {
        return api.post(`${samplesURL}/remove-question/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static uploadUniqueLinks(payload: { [key: string]: any }, id: string): Promise<any> {
        return api.post(`${samplesURL}/uploadUniqueLinks?id=${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }
    static Total_no_panelist(values: any, id: string): Promise<any> {
        return api.post(`${samplesURL}/noOfPanelistCount`, {})
            .then((res) => {
                return (res);
            });
    }
    static targetpanelistAPI(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${samplesURL}/noOfPanelistCount`, payload)
            .then((res) => {
                return res;
            })
           
    }
    
    static getOneSampleUsersexport(
        id : string
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getOneSampleUsersexport/${id}`, {})
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }

    
    static getsegmentwisedetails(
        payload : any
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getsegmentwisedetails`, payload)
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }
    



  
static uploadFileUniqueIds(payload: { [key: string]: any }): Promise<any> {
    return api.post(`${samplesURL}/SampleUserMetdata`, payload)
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
}  

static updateSampleUserMetdata(payload: { [key: string]: any }): Promise<any> {
    return api.post(`${samplesURL}/updateSampleUserMetdata`, payload)
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
} 

static getAllSampleBasedOnSurvey(payload: { [key: string]: any }): Promise<any> {
    return api.post(`${surveysURL}/getAllSampleBasedOnSurvey`, payload)
        .then((res) => {
            return _.get(res, 'data.data', []);
        });
} 


}
